import React from 'react'

import * as Styled from './styles/TranscriptionLink.styles'
import { linkResolver } from '../../util/linkResolver'
import { TranscriptionIcon } from '../Icons'

const InternalTranscriptionLink = ({ link }) => (
  <Styled.TranscriptionLink to={linkResolver(link)}>
    <TranscriptionIcon />
    <span>Transcript</span>
  </Styled.TranscriptionLink>
)

const ExternalTranscriptionLink = ({ link }) => (
  <Styled.TranscriptionLink as="a" href={link} target="_blank">
    <TranscriptionIcon />
    <span>Transcript</span>
  </Styled.TranscriptionLink>
)

const TranscriptionLink = ({ link }) => {
  if (!link) {
    return null
  }
  if (!link.link_type) {
    return null
  }
  if (link.link_type === 'Document') {
    if (!link.uid) {
      return null
    } // only link to valid page types
    return <InternalTranscriptionLink link={link} />
  }
  if (link.link_type === 'Web' || link.link_type === 'File') {
    return <ExternalTranscriptionLink link={link.url} />
  }
  return null
}

export default TranscriptionLink
